import { Buffer } from "buffer";

import { fileTypeBytePattern, isValidBase64File, readFileDataAsBase64 } from "../../../../shared/file-sanitiser";

/** Used to upload a file to S3, having already got an upload URL */
export async function uploadFileWithValidation(body: File | Blob, fileExt: string, uploadUrl: string) {
  if (isFile(body)) {
    const matchPattern = fileTypeBytePattern(body);
    const bytes = (await readFileDataAsBase64(body)) as string;
    const base64Data = Buffer.from(bytes.replace(matchPattern, ""), "base64");

    if (!isValidBase64File(base64Data, fileExt)) {
      throw new Error("Invalid file format ");
    }
  }

  const response = await fetch(uploadUrl, { method: "PUT", body });
  if (!response.ok) throw new Error("Failed to upload");
}

const isFile = (data: unknown): data is File => (data as File).lastModified !== undefined;
